import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { AgentInfo } from "../../../../api/types/inboxesTypes";

export interface Props {
  hasEditPermissions: boolean;
  agents: AgentInfo[];
}

const AgentInboxesContext = createContext<Props | undefined>(undefined);

export const AgentInboxesContextProvider = ({ children, ...props }: PropsWithChildren<Props>) => (
  <AgentInboxesContext value={props}>{children}</AgentInboxesContext>
);

export default AgentInboxesContext;
